import {LogType} from '@gongxigames/framework/core/fragments/ConsoleLogger';

export type Tags = {
    [key: string]: string|boolean;
};

export type ExtraData = {
    [key: string]: any;
};

export abstract class BaseErrorReporterWrapper {
    public abstract init(): void;
    public abstract setTags(tags: Tags): void;
    public abstract addExtraData(tags: ExtraData): void;
    public abstract receiver(logType: LogType, logData: any[]): void;
    public abstract disable(): void;
}
